export const faqsPl = [
  {
    q: "Kiedy potrzebuję SaaS na zamówienie zamiast gotowego produktu?",
    a: "Gdy gotowy SaaS nie pasuje do procesu, ról użytkowników albo integracji. Dedykowana platforma ma sens, gdy produkt jest rdzeniem biznesu, a nie tylko narzędziem pomocniczym.",
  },
  {
    q: "Ile kosztuje MVP platformy SaaS?",
    a: "MVP SaaS (rejestracja, role, panel, podstawowa subskrypcja — np. React + Node + PostgreSQL) to najczęściej zakres od ok. 80 000 do 300 000+ zł, zależnie od multi-tenant, płatności i integracji. Dajemy orientacyjną wycenę po warsztatach.",
  },
  {
    q: "Czy budujecie płatności Stripe, Przelewy24, BLIK?",
    a: "Tak. Subskrypcje i płatności europejskie planujemy już na etapie MVP, nie dokładamy ich „na końcu”.",
  },
  {
    q: "Czy SaaS może być multi-tenant (wielu klientów)?",
    a: "Tak. Projektujemy izolację danych, role (twórca / klient / admin) i skalowanie od pierwszego dnia — albo zaczynamy od prostszego modelu i ewolucyjnie przechodzimy na multi-tenant.",
  },
  {
    q: "Fixed price czy time & material przy SaaS?",
    a: "MVP z jasnym zakresem często da się wycenić fixed price. Dalszy rozwój produktu SaaS zwykle lepiej działa w time & material albo hybrydzie — bo priorytety zmieniają się po kontakcie z użytkownikami.",
  },
  {
    q: "Czy możecie dodać AI do platformy SaaS?",
    a: "Tak — jako funkcję produktu (chatbot, rekomendacje, automatyzacja). Szczegóły kosztów i RODO omawiamy na stronie integracji AI.",
  },
  {
    q: "Czy SaaS może być zgodny z RODO?",
    a: "Tak. Projektujemy hosting w UE, umowy powierzenia, role dostępu i retencję danych — szczególnie przy SaaS dla wielu klientów (np. edukacja, medtech, usługi B2B).",
  },
  {
    q: "Jak długo trwa MVP SaaS?",
    a: "Wąskie MVP to zwykle kilka–kilkanaście tygodni przy jasnym zakresie. Pełna platforma z płatnościami, multi-tenant i hardeningiem to dłuższy cykl — dzielimy go na etapy z mierzalnymi kamieniami milowymi.",
  },
] as const;
